/**
 * First-party relative + absolute time formatting using the built-in
 * Intl.RelativeTimeFormat (no third-party dependency).
 *
 * Timestamps arrive from the API as ISO-8601 UTC; both helpers render in the
 * viewer's local timezone.
 */

const RTF = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'seconds' },
  { amount: 60, unit: 'minutes' },
  { amount: 24, unit: 'hours' },
  { amount: 7, unit: 'days' },
  { amount: 4.34524, unit: 'weeks' },
  { amount: 12, unit: 'months' },
  { amount: Number.POSITIVE_INFINITY, unit: 'years' },
]

/** "3 hours ago", "in 2 days", "just now" — or "never" for null/empty input. */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return 'never'
  const ms = new Date(iso).getTime()
  if (Number.isNaN(ms)) return 'never'

  let duration = (ms - Date.now()) / 1000
  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return RTF.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }
  return 'never'
}

/** "12 Jun 2026, 08:14" in local time — or an em dash for null/empty input. */
export function absoluteTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
